import { graphql } from '@/gql';

export const RadioQuestionFragment = graphql(`
  fragment RadioQuestionFragment on YesNoQuestion {
    id
    answer
    question
    relevance
    productId
    description
    tailoredBuildingBlocks {
      id
      name
    }
    tailoredDesignObligations {
      id
      name
    }
  }
`);

export const CheckboxQuestionFragment = graphql(`
  fragment CheckboxQuestionFragment on CheckboxQuestion {
    id
    question
    relevance
    options {
      option
      answer
    }
  }
`);

export const BuildingBlockFragment = graphql(`
  fragment BuildingBlockFragment on ProductBuildingBlock {
    inclusion {
      __typename
      actual
      source
      explanation
    }
    maturityStages {
      id
      name
      description
    }
    informations {
      id
      description
      link
      linkText
      classification
    }
    designObligation {
      id
      name
      description
    }
    dataBlocks {
      id
      name
      description
      definitionOfDone
    }
    id
    productId
    name
    targetState
    why
    consequencesOfNoResponse
    applicableFor
    preconditionAssumptions
    definitionOfDone
  }
`);

export const PretailorProductFragment = graphql(`
  fragment PreTailorProductFragment on Product {
    id
    name
    description
    owner
    lifecycleStatus
    productIdentifier
    projectIdentifier
    version
    updatedAt
    tailoringProcess {
      questions {
        __typename
        ...RadioQuestionFragment
        ...CheckboxQuestionFragment
      }
      buildingBlocks {
        ...BuildingBlockFragment
      }
    }
  }
`);

export const getProduct = graphql(`
  query getProduct($id: ID!) {
    product(id: $id) {
      ...PreTailorProductFragment
    }
  }
`);

export const answerQuestion = graphql(`
  mutation answerQuestion($answerPretailoringInput: AnswerPretailoringInput!) {
    answerPretailoring(answerPretailoringInput: $answerPretailoringInput) {
      id
      name
      description
      owner
      lifecycleStatus
      productIdentifier
      projectIdentifier
      version
      updatedAt
      tailoringProcess {
        questions {
          __typename
          ...RadioQuestionFragment
          ...CheckboxQuestionFragment
        }
        buildingBlocks {
          ...BuildingBlockFragment
        }
      }
    }
  }
`);
